//import inViewportMixin from './vue-in-viewport-mixin'
import EventBus from '@/helper/EventBus.js'

export default {
	// Public interface
	props: {
		layoutId: {
			type     : [String],
			default  : '',
			required : false,
		},
		data: {
			type     : [Object],
			default  : ()=> { return {} },
			required : false,
		},
		path: {
			type     : [String],
			default  : '',
			required : false,
		},
		parentPath: {
			type     : [String],
			default  : '',
			required : false,
		},
		index: {
			type     : [Number],
			default  : 0,
			required : false,
		},
		isSelected: {
			type     : [Boolean],
			default  : false,
			required : false,
		},
		isHovered: {
			type     : [Boolean],
			default  : false,
			required : false,
		},
		isGuiVisible: {
			type     : [Boolean],
			default  : false,
			required : false,
		},
	},
	// Bindings that are used by the host component
	data() {
		return {};
	},
	mixins: [
		//inViewportMixin,
	],
	// Lifecycle hooks
	mounted(){
		//console.log( this.$options.name, '• mounted' )
	},
	destroyed(){},
	computed: {},
	// Watch props and data
	watch: {},
	// Public API
	methods: {
		XXXonClick( doLog = true ){
			const layoutId = this.layoutId
			const path = this.path
			const type = this.data.type
			const id = this.data.id

			// groupCollapsed group
			if( doLog ){
				console.groupCollapsed( this.$options.name, '• onClick()' )
				console.log('layoutId:', layoutId)
				console.log('path:', path)
				console.log('type:', type)
				console.log('id:', id)
				console.groupEnd()
			}
		},
		XXXonDoubleClick( doLog = true ){
			const layoutId = this.layoutId
			const path = this.path
			const type = this.data.type
			const id = this.data.id

			// groupCollapsed group
			if( doLog ){
				console.groupCollapsed( this.$options.name, '• onDoubleClick()' )
				console.log('layoutId:', layoutId)
				console.log('path:', path)
				console.log('type:', type)
				console.log('id:', id)
				console.groupEnd()
			}

			EventBus.$emit('selectItem', {
				layoutId : layoutId,
				path : path,
				type : type,
				id : id,
			}, false)
		},
	}
}
